"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WaitlistOptInSuccessBanner = exports.RegulatedSpacesBanner = exports.NoResultsBanner = exports.SchedulingHelpBanner = exports.DeepLinkingUnavailableSlotBanner = exports.AppointmentUnavailableBanner = exports.UnavailableToScheduleBanner = exports.ErrorBookingBanner = exports.CallToBookBanner = exports.NoOnlineBookingBanner = exports.EmergencyBanner = exports.WarningBanner = exports.AlertBanner = exports.InfoBanner = void 0;
const react_1 = __importDefault(require("react"));
const framer_motion_1 = require("framer-motion");
const intl_1 = require("@kyruus/intl");
const button_1 = __importStar(require("@kyruus/button"));
const banner_1 = __importDefault(require("@kyruus/banner"));
const Cancel_1 = __importDefault(require("@kyruus/react-ikons/Cancel"));
const messages_1 = __importDefault(require("../../lib/messages"));
const Filters_1 = require("../../lib/constants/Filters");
const styles_1 = require("./styles");
const PhoneNumberLink_1 = __importDefault(require("../PhoneNumberLink/PhoneNumberLink"));
const utils_1 = require("../../lib/utils");
const InfoBanner = (_a) => {
    var { children } = _a, props = __rest(_a, ["children"]);
    return (react_1.default.createElement(banner_1.default, Object.assign({}, props, { type: "info", icon: "i" }), children));
};
exports.InfoBanner = InfoBanner;
const AlertBanner = (_a) => {
    var { children, onClose } = _a, props = __rest(_a, ["children", "onClose"]);
    return (react_1.default.createElement(banner_1.default, Object.assign({}, props, { type: "alert", icon: "!", action1Text: react_1.default.createElement(Cancel_1.default, null), action1: "close", onClose: onClose }), children));
};
exports.AlertBanner = AlertBanner;
const WarningBanner = (_a) => {
    var { children } = _a, props = __rest(_a, ["children"]);
    return (react_1.default.createElement(banner_1.default, Object.assign({}, props, { icon: "!", type: "warning" }), children));
};
exports.WarningBanner = WarningBanner;
const EmergencyBanner = ({ children, onClose }) => (react_1.default.createElement(exports.AlertBanner, { "data-testid": "EmergencyBanner", onClose: onClose }, children));
exports.EmergencyBanner = EmergencyBanner;
exports.NoOnlineBookingBanner = (0, intl_1.injectIntl)((_a) => {
    // Have to couple mountscrolling because intlV2 doesn't support ref forwarding.
    // TODO: Use MountScroller if we ever upgrade to intlV3
    var { intl, patientRel, providerName, phone } = _a, props = __rest(_a, ["intl", "patientRel", "providerName", "phone"]);
    // Create the ref to pass to the child
    const ref = react_1.default.createRef();
    // Scroll the child into view only on mount
    react_1.default.useEffect(() => {
        ref.current.scrollIntoView && ref.current.scrollIntoView(false);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return (react_1.default.createElement("div", { ref: ref },
        react_1.default.createElement(exports.WarningBanner, Object.assign({ "data-testid": "NoOnlineBookingBanner" }, props),
            react_1.default.createElement(intl_1.FormattedMessage, Object.assign({}, messages_1.default.noapptpurposes, { values: {
                    provider_name: providerName,
                    patient_status: patientRel === Filters_1.NEW_PATIENT
                        ? intl.formatMessage(messages_1.default.new)
                        : intl.formatMessage(messages_1.default.established)
                } })),
            react_1.default.createElement("br", null),
            phone && (react_1.default.createElement(intl_1.FormattedMessage, Object.assign({}, messages_1.default.contactoffice, { values: {
                    phone_number_link: react_1.default.createElement(PhoneNumberLink_1.default, { phone: phone })
                } }))))));
});
const CallToBookBanner = ({ phone }) => (react_1.default.createElement(exports.WarningBanner, null,
    react_1.default.createElement(intl_1.FormattedMessage, Object.assign({}, messages_1.default.contactPhone, { values: {
            phone_number_link: react_1.default.createElement(PhoneNumberLink_1.default, { phone: phone })
        } }))));
exports.CallToBookBanner = CallToBookBanner;
const ErrorBookingBanner = ({ phone }) => (react_1.default.createElement(exports.WarningBanner, { "data-testid": "ErrorBookingBanner" }, phone ? (react_1.default.createElement(intl_1.FormattedMessage, Object.assign({}, messages_1.default.bookApptError, { values: {
        phone_number_link: react_1.default.createElement(PhoneNumberLink_1.default, { phone: phone })
    } }))) : (react_1.default.createElement(intl_1.FormattedMessage, Object.assign({}, messages_1.default.bookApptErrorNoPhone)))));
exports.ErrorBookingBanner = ErrorBookingBanner;
const UnavailableToScheduleBanner = ({ phone }) => (react_1.default.createElement(exports.WarningBanner, { "data-testid": "UnavailableToScheduleBanner" },
    react_1.default.createElement(intl_1.FormattedMessage, Object.assign({}, messages_1.default.bookApptUnavailableToSchedule)),
    phone && (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("br", null),
        react_1.default.createElement(intl_1.FormattedMessage, Object.assign({}, messages_1.default.contactoffice, { values: {
                phone_number_link: react_1.default.createElement(PhoneNumberLink_1.default, { phone: phone })
            } }))))));
exports.UnavailableToScheduleBanner = UnavailableToScheduleBanner;
const AppointmentUnavailableBanner = () => (react_1.default.createElement(exports.WarningBanner, { "data-testid": "AppointmentUnavailableBanner" },
    react_1.default.createElement(intl_1.FormattedMessage, Object.assign({}, messages_1.default.apptUnavailableError))));
exports.AppointmentUnavailableBanner = AppointmentUnavailableBanner;
exports.DeepLinkingUnavailableSlotBanner = (0, intl_1.injectIntl)(({ slotTime }) => (react_1.default.createElement(exports.WarningBanner, { "data-testid": "DeepLinkingUnavailableSlotBanner" },
    react_1.default.createElement(intl_1.FormattedMessage, Object.assign({}, messages_1.default.deepLinkingUnavailableSlotError, { values: {
            appt_time: slotTime
        } })))));
const SchedulingHelpBanner = ({ className, phone, track = () => { }, onPhoneNumberClick }) => {
    if (!phone)
        return null;
    const handlePhoneNumberClick = () => {
        if (onPhoneNumberClick) {
            onPhoneNumberClick();
        }
        else {
            track('user_action.direct_book.need_help_box.phone_link');
        }
    };
    return (react_1.default.createElement(exports.InfoBanner, { className: className, "data-testid": "SchedulingHelpBanner" },
        react_1.default.createElement(intl_1.FormattedMessage, Object.assign({}, messages_1.default.schedulingHelp, { values: {
                phone_number_link: (react_1.default.createElement(PhoneNumberLink_1.default, { phone: phone, onClick: handlePhoneNumberClick }))
            } }))));
};
exports.SchedulingHelpBanner = SchedulingHelpBanner;
const NoResultsBanner = ({ jumpedToDate, date, isLoading, onClearFilters, onLoadMore, resultsMessage }) => {
    const formattedDate = (0, utils_1.formatLastApptShownDate)(date);
    const formattedJumpToDate = (0, utils_1.formatLastApptShownDate)(jumpedToDate);
    return (react_1.default.createElement(styles_1.NoResultsContainer, { "data-testid": "NoResultsBanner" },
        react_1.default.createElement(exports.InfoBanner, null,
            react_1.default.createElement(styles_1.NoResultsContent, null,
                react_1.default.createElement("div", null,
                    react_1.default.createElement(intl_1.FormattedMessage, Object.assign({}, resultsMessage, { values: {
                            jumpedToDate: (react_1.default.createElement(framer_motion_1.AnimatePresence, null,
                                react_1.default.createElement(framer_motion_1.motion.strong, { key: formattedJumpToDate, initial: { opacity: 0 }, animate: { opacity: 1 }, exit: { opacity: 0 } }, formattedJumpToDate))),
                            date: (react_1.default.createElement(framer_motion_1.AnimatePresence, null,
                                react_1.default.createElement(framer_motion_1.motion.strong, { key: formattedDate, initial: { opacity: 0 }, animate: { opacity: 1 }, exit: { opacity: 0 } }, formattedDate)))
                        }, key: "message" }))),
                react_1.default.createElement("section", null, isLoading ? (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(button_1.default, { "data-testid": "clearBtn", disabled: true },
                        react_1.default.createElement(intl_1.FormattedMessage, Object.assign({}, messages_1.default.noFilteredResultsClearBtn))),
                    react_1.default.createElement(button_1.ButtonWithSpinner, { showSpinner: true, disabled: true },
                        react_1.default.createElement(intl_1.FormattedMessage, Object.assign({}, messages_1.default.noFilteredResultsLoadMoreBtn))))) : (react_1.default.createElement(react_1.default.Fragment, null,
                    onClearFilters != null && (react_1.default.createElement(button_1.default, { onClick: onClearFilters },
                        react_1.default.createElement(intl_1.FormattedMessage, Object.assign({}, messages_1.default.noFilteredResultsClearBtn)))),
                    onLoadMore != null && (react_1.default.createElement(button_1.default, { onClick: onLoadMore },
                        react_1.default.createElement(intl_1.FormattedMessage, Object.assign({}, messages_1.default.noFilteredResultsLoadMoreBtn)))))))))));
};
exports.NoResultsBanner = NoResultsBanner;
exports.RegulatedSpacesBanner = (0, intl_1.injectIntl)(({ intl, location, track = () => { } }) => {
    if (location.email) {
        return (react_1.default.createElement(styles_1.StyledRegulatedSpacesBanner, { icon: "!", type: "warning" },
            react_1.default.createElement(intl_1.FormattedMessage, Object.assign({}, messages_1.default.regulatedSpacesBannerWithLink, { values: {
                    regulated_spaces_link: (react_1.default.createElement(styles_1.RegulatedSpacesLink, { title: intl.formatMessage(messages_1.default.regulatedSpacesBannerLinkTitle, { location_name: location.name }), href: location.email, onClick: () => {
                            track('user_action.direct_book.regulated_spaces_link_click');
                        }, rel: "noopener noreferrer", target: "_blank" },
                        react_1.default.createElement(intl_1.FormattedMessage, Object.assign({}, messages_1.default.clickHere))))
                } }))));
    }
    else {
        return (react_1.default.createElement(styles_1.StyledRegulatedSpacesBanner, { icon: "!", type: "warning" },
            react_1.default.createElement(intl_1.FormattedMessage, Object.assign({}, messages_1.default.regulatedSpacesBanner))));
    }
});
const WaitlistOptInSuccessBanner = () => (react_1.default.createElement(banner_1.default, { type: "success", icon: "check", "data-testid": "waitlist-optin-success" },
    react_1.default.createElement(intl_1.FormattedMessage, Object.assign({}, messages_1.default.waitlistOptInSuccess))));
exports.WaitlistOptInSuccessBanner = WaitlistOptInSuccessBanner;
//# sourceMappingURL=Banners.js.map